/* ============================================================
   VIVĀRA — CART DRAWER
   ------------------------------------------------------------
   A standard drawer on Shopify's own Ajax Cart API. No libraries.

     POST /cart/add.js       add the selected variant + selling plan
     GET  /cart.js           read the cart
     POST /cart/change.js    change a line quantity, or remove at 0

   Behaviour:
   · Add to Cart is intercepted; the page never navigates away
   · the drawer opens on add, and can be opened from the header count
   · quantity steppers and remove per line
   · Escape closes, focus is trapped while open, the page behind is locked
   · the subscription line shows its own recurring note
   · with JavaScript off the form posts normally to /cart, which still
     renders — the drawer is an enhancement, not a dependency

   OFF SHOPIFY (this static build) there is no /cart endpoint, so the
   drawer runs in a demonstration mode: it opens, shows the line that would
   have been added, and says plainly that checkout is not connected. That
   keeps the interaction reviewable without pretending to take money.

   SHOPIFY MIGRATION → assets/vivara-cart.js, snippets/cart-drawer.liquid
   ============================================================ */
(function () {
  "本ポリシーはVIVĀRAで直接ご注文いただいた場合に適用され、お客様の法律上の権利を妨げるものではありません。";

  var HAS_SHOPIFY = !!(window.Shopify || document.documentElement.hasAttribute("data-shopify"));

  var drawer, panel, list, footer, countEls = [], lastFocus = null;

  function money(cents) {
    var P = window.VIVARA_PRODUCT;
    var v = cents / 100;
    var s = (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2);
    return ((P && P.symbol) || "$") + s;
  }

  /* ---------------------------------------------------------- shell */
  function build() {
    drawer = document.createElement("div");
    drawer.className = "cart-drawer";
    drawer.id = "cartDrawer";
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="cart-scrim" data-cart-close></div>' +
      '<aside class="cart-panel" role="dialog" aria-modal="true" aria-labelledby="cartTitle" tabindex="-1">' +
        '<header class="cart-head">' +
          '<h2 class="cart-title" id="cartTitle">カート</h2>' +
          '<button class="cart-close" type="button" data-cart-close aria-label="カートを閉じる">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1" fill="none"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="cart-body" data-cart-list></div>' +
        '<footer class="cart-foot" data-cart-foot></footer>' +
      '</aside>';
    document.body.appendChild(drawer);
    panel = drawer.querySelector(".cart-panel");
    list = drawer.querySelector("[data-cart-list]");
    footer = drawer.querySelector("[data-cart-foot]");

    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-close]")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !drawer.hidden) close();
      if (e.key === "Tab" && !drawer.hidden) trap(e);
    });
  }

  function trap(e) {
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add("cart-open");
    if (window.__vivaraLenis) window.__vivaraLenis.stop();
    requestAnimationFrame(function () {
      drawer.classList.add("is-open");
      panel.focus();
    });
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("cart-open");
    if (window.__vivaraLenis) window.__vivaraLenis.start();
    window.setTimeout(function () {
      if (!drawer.classList.contains("is-open")) drawer.hidden = true;
    }, 360);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------------------------------------------------------- render */
  function setCount(n) {
    countEls.forEach(function (el) {
      el.textContent = n > 0 ? String(n) : "";
      el.classList.toggle("is-empty", n === 0);
    });
  }

  function lineNode(item) {
    var li = document.createElement("article");
    /* Grid places children in order, so a line with no thumbnail needs a
       two-column track rather than an empty 64px gutter. */
    li.className = "cart-line" + (item.image ? "" : " cart-line--noimg");

    if (item.image) {
      var img = document.createElement("img");
      img.className = "cart-line-img";
      img.src = item.image;
      img.alt = "";
      img.width = 120; img.height = 160;
      img.loading = "lazy";
      li.appendChild(img);
    }

    var body = document.createElement("div");
    body.className = "cart-line-body";

    var title = document.createElement("p");
    title.className = "cart-line-title";
    title.textContent = item.product_title || item.title;
    body.appendChild(title);

    /* Shopify names the selected plan under selling_plan_allocation. Reading
       a flat selling_plan_name (which the Cart API never returns) is why a
       subscription line in the drawer looked exactly like a one-time one. */
    var planName = (item.selling_plan_allocation &&
                    item.selling_plan_allocation.selling_plan &&
                    item.selling_plan_allocation.selling_plan.name) || item.selling_plan_name;
    if (planName) {
      var plan = document.createElement("p");
      plan.className = "cart-line-plan";
      plan.textContent = planName;
      body.appendChild(plan);
    }

    var qty = document.createElement("div");
    qty.className = "cart-qty";

    function step(label, delta, aria) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "cart-qty-btn";
      b.textContent = label;
      b.setAttribute("aria-label", aria);
      b.addEventListener("click", function () { change(item.key, item.quantity + delta); });
      return b;
    }

    var count = document.createElement("span");
    count.className = "cart-qty-n";
    count.setAttribute("aria-live", "polite");
    count.textContent = item.quantity;

    qty.appendChild(step("−", -1, "数量を減らす"));
    qty.appendChild(count);
    qty.appendChild(step("+", 1, "数量を増やす"));
    body.appendChild(qty);

    var remove = document.createElement("button");
    remove.type = "button";
    remove.className = "cart-line-remove";
    remove.textContent = "削除";
    remove.addEventListener("click", function () { change(item.key, 0); });
    body.appendChild(remove);

    var price = document.createElement("p");
    price.className = "cart-line-price";
    price.textContent = money(item.final_line_price);

    li.appendChild(body);
    li.appendChild(price);
    return li;
  }

  function render(cart) {
    list.innerHTML = "";
    footer.innerHTML = "";
    setCount(cart.item_count || 0);

    if (!cart.item_count) {
      var empty = document.createElement("p");
      empty.className = "cart-empty";
      empty.textContent = "カートは空です。";
      list.appendChild(empty);
      return;
    }

    (cart.items || []).forEach(function (item) { list.appendChild(lineNode(item)); });

    var row = document.createElement("div");
    row.className = "cart-total";
    row.innerHTML = '<span>小計</span><span>' + money(cart.total_price) + "</span>";
    footer.appendChild(row);

    var note = document.createElement("p");
    note.className = "cart-note";
    note.textContent = "送料と税は購入手続きで計算されます。";
    footer.appendChild(note);

    if (HAS_SHOPIFY) {
      var go = document.createElement("form");
      go.action = "/cart";
      go.method = "post";
      go.innerHTML = '<button class="cart-checkout" type="submit" name="checkout">Checkout — ' +
                     money(cart.total_price) + "</button>";
      footer.appendChild(go);
    } else {
      var stub = document.createElement("p");
      stub.className = "cart-note cart-note--stub";
      stub.textContent = "購入手続きは公開中のストアで有効です。このプレビューでは動作しません。";
      footer.appendChild(stub);
    }
  }

  /* ---------------------------------------------------------- data */
  function fetchCart() {
    if (!HAS_SHOPIFY) return Promise.resolve(LOCAL);
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : EMPTY; })
      /* A cart that cannot be read must never break the page. */
      .catch(function () { return EMPTY; });
  }

  function change(key, quantity) {
    if (!HAS_SHOPIFY) {
      LOCAL.items = LOCAL.items.filter(function (i) { return i.key !== key || quantity > 0; });
      LOCAL.items.forEach(function (i) {
        if (i.key === key) { i.quantity = quantity; i.final_line_price = i.price * quantity; }
      });
      recalcLocal();
      render(LOCAL);
      return;
    }
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.ok ? r.json() : EMPTY; })
      .catch(function () { return EMPTY; })
      .then(render);
  }

  var EMPTY = { item_count: 0, total_price: 0, items: [] };

  /* A stand-in cart for the static preview only. */
  var LOCAL = { item_count: 0, total_price: 0, items: [] };
  function recalcLocal() {
    LOCAL.item_count = LOCAL.items.reduce(function (n, i) { return n + i.quantity; }, 0);
    LOCAL.total_price = LOCAL.items.reduce(function (n, i) { return n + i.final_line_price; }, 0);
  }

  function add(form) {
    var P = window.VIVARA_PRODUCT || {};
    var planField = form.querySelector("[data-selling-plan]");
    var plan = planField && planField.value ? planField.value : null;

    if (!HAS_SHOPIFY) {
      var subscribing = !!plan;
      var unit = Math.round((subscribing ? P.subscriptionPrice : P.oneTimePrice) * 100);
      var key = subscribing ? "preview-sub" : "preview-one";
      var found = LOCAL.items.filter(function (i) { return i.key === key; })[0];
      if (found) found.quantity += 1;
      else LOCAL.items.push({
        key: key,
        product_title: P.fullName || "Element 003",
        image: (document.documentElement.getAttribute("data-base") || "") + "assets/img/product.jpg",
        selling_plan_name: subscribing ? "定期購入 · " + P.subscriptionIntervalDays + " days" : null,
        quantity: 1,
        price: unit
      });
      LOCAL.items.forEach(function (i) { i.final_line_price = i.price * i.quantity; });
      recalcLocal();
      render(LOCAL);
      open();
      return;
    }

    var body = { items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }] };
    if (plan) body.items[0].selling_plan = plan;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    })
      /* A rejected add used to resolve quietly and the drawer opened on the
         old cart, which reads as "nothing happened". Say so instead. */
      .then(function (r) { return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || "カートに追加できませんでした");
        return d;
      }); })
      .then(function () { return fetchCart(); })
      .then(function (cart) { render(cart); open(); })
      .catch(function (err) {
        if (err && err.message) { notify(form, err.message); return; }
        form.submit();   /* a network failure falls back to a normal post */
      });
  }

  function notify(form, message) {
    var box = form.querySelector("[data-cart-error]");
    if (!box) {
      box = document.createElement("p");
      box.className = "cart-error";
      box.setAttribute("data-cart-error", "");
      box.setAttribute("role", "alert");
      var cta = form.querySelector("[data-cta]");
      if (cta && cta.parentNode) cta.parentNode.insertBefore(box, cta.nextSibling);
      else form.appendChild(box);
    }
    box.textContent = message;
  }

  /* ---------------------------------------------------------- init */
  function init() {
    build();
    countEls = [].slice.call(document.querySelectorAll("[data-cart-count]"));

    document.querySelectorAll("[data-cart-open]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        fetchCart().then(function (cart) { render(cart); open(); });
      });
    });

    document.querySelectorAll("form[action*='/cart/add'], form[data-product-form], form.purchase").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        add(form);
      });
    });

    fetchCart().then(function (cart) { setCount(cart.item_count || 0); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
